import { gql } from "hooks/urql"

export default gql`
  fragment LessonResourcesFields on LessonResource {
    id
    name
    sortOrder
    file {
      filename
      previewUrl
      thumbUrl
    }
  }
`
